import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import composeModalActions from 'src/utils/modal-action-wrapper';
import { dateTimeFormatter, expiredFormatter } from 'src/utils/formatters';
import { calculateAvailableTickets, getExpiredTickets } from 'src/components/event-tickets/calculations';

import TableHelper from 'src/utils/table-helper';
import ErrorMessage from 'src/components/misc/error-message';
import { withTranslation } from 'react-i18next';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';

class TicketEventAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper({ onRowClick: this.onSelectEvent });
        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        this.props.fetchTicketEventsJoinFetchTickets();
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.modal.open;
    }

    componentWillReceiveProps(nextProps) {
        const { ticketEvents } = nextProps;

        if (ticketEvents.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });

        this.tableHelper.processPagination(ticketEvents.items.length);
    }

    componentDidUpdate(prevProps) {
        if (this.tableHelper.processPaginationAfterUpdate(prevProps.ticketEvents, this.props.ticketEvents, this.table))
            this.setState({ renderSelection: !this.state.renderSelection });
    }

    render() {
        const { ticketEvents, t } = this.props;
        const finishFetching = this.state.startedFetching && !ticketEvents.isFetching;

        const tableData = [];
        if (finishFetching && ticketEvents.items.length > 0) {
            ticketEvents.items.map(ticketEvent => {
                let totalTickets = 0,
                    soldTickets = 0,
                    expiredTickets = 0;

                if (ticketEvent.ticketCollections && ticketEvent.ticketCollections.length > 0)
                    ticketEvent.ticketCollections.forEach(ticketCollection => {
                        totalTickets += ticketCollection.quantity;
                        soldTickets += ticketCollection.countSold;
                        expiredTickets += getExpiredTickets(ticketCollection);
                    });

                tableData.push({
                    id: ticketEvent.id,
                    name: ticketEvent.name,
                    category: ticketEvent.eventCategory.name,
                    beginDateTime: ticketEvent.beginDateTime,
                    isExpired: ticketEvent.expired,
                    location: ticketEvent.location.address,
                    availableTickets: calculateAvailableTickets(totalTickets, soldTickets, expiredTickets),
                });
            });
        }

        return (
            <div>
                <legend className="legend">{t('common_phrases.events')}</legend>

                {(() => {
                    if (ticketEvents.error) return <ErrorMessage object={ticketEvents} />;
                    else
                        return (
                            <div className="clickableTable">
                                <BootstrapTableErrorBoundary>
                                    <BootstrapTable
                                        ref={ref => (this.table = ref)}
                                        data={tableData}
                                        exportCSV={true}
                                        striped={true}
                                        hover={true}
                                        condensed={true}
                                        pagination={true}
                                        options={Object.assign({}, this.tableHelper.getOptions(finishFetching))}
                                        selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                                        searchPlaceholder={t('common_phrases.search')}
                                        search={true}>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="id"
                                            hidden={true}
                                            isKey={true}
                                            export={true}>
                                            {t('common_phrases.id')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn columnTitle={true} dataField="name" dataSort={true}>
                                            {t('common_phrases.name')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="beginDateTime"
                                            dataFormat={dateTimeFormatter}
                                            dataSort={true}>
                                            {t('events.beginning')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn columnTitle={true} dataField="location" dataSort={true}>
                                            {t('events.location_event')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn columnTitle={true} dataField="category" dataSort={true}>
                                            {t('common_phrases.category')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="isExpired"
                                            dataFormat={cell => expiredFormatter(t, cell)}
                                            width="90"
                                            dataAlign="center"
                                            dataSort={true}>
                                            {t('events.status')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="availableTickets"
                                            dataAlign="right"
                                            dataSort={true}>
                                            {t('ticket.available_tickets')}
                                        </TableHeaderColumn>
                                    </BootstrapTable>
                                </BootstrapTableErrorBoundary>
                            </div>
                        );
                })()}
            </div>
        );
    }

    onSelectEvent(event) {
        this.props.push('/event-tickets/events/' + event.id);
    }
}

export default withTranslation()(composeModalActions(TicketEventAdministration));
